export const topicCommunityTabs = {
  overview: 'overview',
  discussion: 'discussion',
  initiatives: 'initiatives',
  knowledgeHub: 'knowledgeHub',
  contactInfo: 'contactInfo',
  events: 'events',
} as const

export const topicCommunityTabsQueryParamName = 'tab'
